var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags"},_vm._l((_vm.breadCrumbs),function(tag){return (tag.name)?_c('el-tag',{key:tag.name,attrs:{"closable":"","type":_vm.currentSelect.name === tag.name ? 'success' : ''},on:{"close":function($event){return _vm.remove(tag)},"click":function($event){return _vm.taglick(tag)}}},[_vm._v(" "+_vm._s(tag.name)+" ")]):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }